import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// بيرجع لأعلى الصفحة أوتوماتيك كل ما الراوت يتغير (زي التنقل بين صفحات المتجر)
const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTopOnRouteChange;
